import React from "react";
import { useUserQuery } from "../hooks/useUserQuery";
import { userShape } from "../shapes";

type WithUserProps = {
  user: userShape;
};

const withUser = <T extends WithUserProps = WithUserProps>(
  ChildComponent: React.ComponentType<T>,
) => {
  function ConnectedComponent(props: Readonly<Omit<T, keyof WithUserProps>>) {
    const userQuery = useUserQuery();

    return userQuery.data ? (
      <ChildComponent {...(props as T)} user={userQuery.data} />
    ) : null;
  }
  ConnectedComponent.displayName =
    ChildComponent.displayName ?? ChildComponent.name;
  return ConnectedComponent;
};

export default withUser;
